<span class="brand">
  <img src="assets/images/square-control-mark.svg" width="28" height="28" alt="">
  <span>Square Control</span>
</span>
